module.exports = __webpack_public_path__ + "img/Aruodo.ace025f3.png";